import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { HomeScreen } from "../screens/store/home/HomeScreen";
import { Operations } from "../screens/store/operations/Operations";
import { ProductScreen } from "../screens/store/product/ProductScreen";
import { OrdersScreen } from "../screens/store/orders/Orders";
import OrderStatistics from "../screens/store/statics/OperationsStatics";

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { WSOperation } from "../services/remote/operation/WSOperation";
import { WSProduct } from "../services/remote/product/WSProduct";
import { WSOrder } from "../services/remote/order/WSOrder";
import { WSDeliveryInstance } from "../services/remote/delivery/WSDelivery";
import { selectStore } from "../store/selectors/StoreSelector";
import { setLoading } from "../store/slices/LoadingSlice";
import {
  incrementNewOrderCount,
  setNewOrderCount,
  setOrders,
} from "../store/slices/OrderSlice";
import { setOperations } from "../store/slices/OperationSlice";
import { setProducts } from "../store/slices/ProductSlice";
import { setDeliveryCompanies } from "../store/slices/DeliverySlice";
import { setStoreConfig } from "../store/slices/StoreConfigSlice";
import ProductDetails from "../screens/store/product/ProductDeatils";
import { StoreDeliveryScreen } from "../screens/store/delivery/StoreDeliveryScreen";
import { ROUTES } from "../services/configuration/Configuration";
import { TeamScreen } from "../screens/store/team/TeamScreen";
import { VRoutes } from "./Routes";
import { selectUser } from "../store/selectors/UserSelector";
import { UserRole } from "../entity/User";
import StoreProfile from "../screens/store/settings/StoreProfile";
import { VParamsRoutes } from "./VParams";
import { MemberScreen } from "../screens/store/team/MemberScreen";
import PaymentScreen from "../screens/store/payment/PaymentScreen";
import { AccessManager } from "../helpers/accessManager/AccessManager";
import { SupportByChatScreen } from "../screens/store/support/SupportByChatScreen";

const StoreRoutes = () => {
  const operationInstance = WSOperation.getInstance();
  const productInstance = WSProduct.getInstance();
  const orderInstance = WSOrder.getInstance();
  const deliveryInstance = WSDeliveryInstance;

  const store = useSelector(selectStore);
  const user = useSelector(selectUser);

  const dispatch = useDispatch();

  const fetchProducts = () => {
    productInstance
      .getAllProducts(store?.id!!)
      .then((products) => {
        if (products) {
          dispatch(setProducts(products));
        }
      })
      .finally(() => {
        dispatch(setLoading(false));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchOperations = () => {
    operationInstance
      .getAllOperations(store?.id!!)
      .then((operations) => {
        dispatch(setOperations(operations));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const updateOrdersStatus = () => {
    orderInstance.updateStatus(store?.id!!).catch((error) => {
      console.error(error);
    });
  };

  const fetchDeliveryCompanies = () => {
    deliveryInstance.getDeliveryCompanies().then((companies) => {
      dispatch(setDeliveryCompanies(companies));
    });
  };

  const fetchStoreConfig = () => {
    deliveryInstance
      .getStoreDeliveryConfigurationsByStoreID(store?.id!!)
      .then((config) => {
        dispatch(setStoreConfig(config));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    dispatch(setLoading(true));
    switch (user?.role) {
      case UserRole.ADMIN:
      case UserRole.SUBADMIN:
      case UserRole.STORE_ADMIN:
        fetchProducts();
        fetchOperations();
        updateOrdersStatus();
        fetchDeliveryCompanies();
        fetchStoreConfig();
        break;
      case UserRole.STORE_CONFIRMER:
        fetchProducts();
        updateOrdersStatus();
        break;
      case UserRole.STORE_EDITOR:
        fetchProducts();
        fetchDeliveryCompanies();
        updateOrdersStatus();
        break;
    }
    dispatch(setLoading(false));
  }, [user]);

  useEffect(() => {
    if (!store?.id) return;

    const unsubscribe = orderInstance.getAllOrdersRealtime(
      store.id,
      (orders) => {
        dispatch(setOrders(orders));
        dispatch(incrementNewOrderCount());
      },
      (error) => {
        console.error(error);
      },
    );

    return () => {
      unsubscribe();
    };
  }, [store?.id]);

  return (
    <Routes>
      {AccessManager.getInstance().hasAccess() ? (
        <>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/operations" element={<Operations />} />
          <Route path="/products" element={<ProductScreen />} />
          <Route path="/orders" element={<OrdersScreen />} />
          <Route path="/statistics/operations" element={<OrderStatistics />} />
          <Route path="/products/:id" element={<ProductDetails />} />
          <Route path="/settings" element={<StoreProfile />} />
          <Route path="/store/delivery" element={<StoreDeliveryScreen />} />
          <Route path={VRoutes.STORE_TEAM} element={<TeamScreen />} />
          <Route
            path={`${VRoutes.STORE_TEAM_MEMBER}:${VParamsRoutes.USER_ID}`}
            element={<MemberScreen />}
          />
          <Route path="/payment" element={<PaymentScreen />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route
            path={VRoutes.SUPPORT_BY_CHAT}
            element={<SupportByChatScreen />}
          />
        </>
      ) : (
        <>
          <Route path="/" element={<Navigate to="/dashboard/payment" />} />

          <Route path="/operations" element={<PaymentScreen />} />
          <Route path="/products" element={<PaymentScreen />} />
          <Route path="/orders" element={<PaymentScreen />} />
          <Route path="/statistics/operations" element={<PaymentScreen />} />
          <Route path="/products/:id" element={<PaymentScreen />} />
          <Route path="/settings" element={<PaymentScreen />} />
          <Route path="/store/delivery" element={<PaymentScreen />} />
          <Route path={VRoutes.STORE_TEAM} element={<PaymentScreen />} />
          <Route
            path={`${VRoutes.STORE_TEAM_MEMBER}:${VParamsRoutes.USER_ID}`}
            element={<PaymentScreen />}
          />
          <Route path="/payment" element={<PaymentScreen />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      )}
    </Routes>
  );
};

export default StoreRoutes;
